import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import mariaAvatar from "../../../assets/maria-m-avatar.jpeg";

export default function HomeQuickMariaChatModal({
  open,
  onClose,
  userName = "Viviane",
  onAddWaterQuick,
}) {
  const navigate = useNavigate();
  const [inputText, setInputText] = useState("");
  const [chatMessages, setChatMessages] = useState([
    {
      sender: "maria",
      text: `🌸 Olá, ${userName}! Vi que você eliminou 4,2 kg até agora e tem sua rotina de cuidados ativa. Como posso te apoiar hoje?`,
    },
  ]);

  if (!open) return null;

  const handleSend = (e) => {
    if (e) e.preventDefault();
    if (!inputText.trim()) return;

    const userMsg = inputText.trim();
    setChatMessages((prev) => [...prev, { sender: "user", text: userMsg }]);
    setInputText("");

    setTimeout(() => {
      setChatMessages((prev) => [
        ...prev,
        {
          sender: "maria",
          text: `Entendido! Estou acompanhando sua rotina. Se quiser um atendimento completo e aprofundado, podemos abrir a sessão completa no MarIA Bot.`,
        },
      ]);
    }, 600);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 backdrop-blur-xs p-0 sm:p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg bg-white rounded-t-[32px] sm:rounded-[32px] p-5 shadow-2xl border-t sm:border border-purple-100 flex flex-col max-h-[85vh] animate-in slide-in-from-bottom duration-200"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Puxador mobile */}
        <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mb-3 sm:hidden" />

        {/* Cabeçalho */}
        <div className="flex items-center justify-between pb-3 border-b border-gray-100">
          <div className="flex items-center gap-2.5">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-[#5B38C2] to-[#8C6CE8] text-white flex items-center justify-center font-black text-base shadow-sm overflow-hidden p-0.5">
              <img
                src={mariaAvatar}
                alt="MarIA"
                className="w-full h-full object-cover object-top rounded-[10px]"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=160&auto=format&fit=crop&q=80";
                }}
              />
            </div>
            <div>
              <h4 className="text-sm font-black text-gray-900 leading-tight flex items-center gap-1.5">
                MarIA Assistente
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
              </h4>
              <span className="text-[11px] font-semibold text-gray-500">
                Inteligência de Saúde & Cuidado
              </span>
            </div>
          </div>

          <div className="flex items-center gap-1.5">
            <button
              type="button"
              onClick={() => {
                onClose();
                navigate("/app/maria-bot");
              }}
              className="text-[11px] font-bold text-[#5B38C2] bg-purple-50 hover:bg-purple-100 px-2.5 py-1 rounded-xl transition"
            >
              Abrir Completo ↗
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-gray-200 transition"
            >
              ✕
            </button>
          </div>
        </div>

        {/* Mensagens */}
        <div className="py-4 space-y-3 overflow-y-auto flex-1 max-h-[340px]">
          {chatMessages.map((msg, idx) => (
            <div
              key={idx}
              className={`p-3.5 rounded-2xl text-xs font-medium leading-relaxed max-w-[88%] ${
                msg.sender === "maria"
                  ? "bg-purple-50 rounded-tl-xs border border-purple-100 text-gray-800"
                  : "bg-[#5B38C2] text-white rounded-tr-xs ml-auto shadow-xs"
              }`}
            >
              {msg.text}
            </div>
          ))}

          {/* Atalhos Rápidos */}
          <div className="flex flex-wrap gap-1.5 pt-1">
            <button
              type="button"
              onClick={() => {
                if (onAddWaterQuick) onAddWaterQuick();
                onClose();
              }}
              className="px-2.5 py-1.5 rounded-xl bg-purple-100/70 text-[#5B38C2] text-[11px] font-bold hover:bg-purple-200 transition active:scale-95"
            >
              💧 Registrei +250ml de água
            </button>
            <button
              type="button"
              onClick={() => {
                onClose();
                navigate("/app/routine");
              }}
              className="px-2.5 py-1.5 rounded-xl bg-purple-100/70 text-[#5B38C2] text-[11px] font-bold hover:bg-purple-200 transition active:scale-95"
            >
              ⏰ Ver doses ativas de hoje
            </button>
          </div>
        </div>

        {/* Campo de Envio */}
        <form onSubmit={handleSend} className="pt-2 flex gap-2 border-t border-gray-100">
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            placeholder="Fale ou digite para a MarIA..."
            className="flex-1 bg-gray-100 text-xs font-medium px-4 py-3 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#5B38C2]"
          />
          <button
            type="submit"
            className="w-11 h-11 rounded-2xl bg-[#5B38C2] hover:bg-[#4A2E99] text-white flex items-center justify-center shadow-md active:scale-95 transition"
          >
            ➤
          </button>
        </form>
      </div>
    </div>
  );
}
